var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z","stroke":"currentColor","strokeWidth":"0.8","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.40039 4.84976V3.69995H7.60039V4.84976H6.40039ZM6.40039 10.8498V5.99976H7.60039V10.8498H6.40039Z","fill":"currentColor","key":1})]);
}

Info.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Info;

Info.default = Info;
